module.exports = __webpack_public_path__ + "img/dashboard.acaf89b.png";